import axios from 'axios';
import config from 'Config';
import { parse } from 'Libs/qs';

const { api } = config;

const http = axios.create({
  baseURL: api.getUrl()
});

export async function getData() {
  const params = {

    published: api.published,
    pending: false,
    ...parse(location.search)
  };
 
  /**
   * wrong way of doing it 
   * TODO needs to correct
   */
  if(params.id=="intel")
  {
    location.replace("https://www.anthem.com/ca/intel");
  }

  const { data } = (await http.get('getPublicData.json', { params }));

  if (data.errorcode && data.errorText)
    throw new Error('Bad Request. Failed to retrieve data');

  data.oeMaterials = {
    ...data.oeMaterials,

  };
  return data;
}
